import React from 'react'
import { Link, usePage } from '@inertiajs/react'

import Layout from '@/Shared/Layout'

import DesignationTable from './Shared/DesignationTable'

const Edit = () => {
    const {
        hr,
        auth: { user }
    } = usePage().props

    return (
        <div>
            {user.role === '1' && (
                <h1 className="mb-8 text-3xl font-bold">
                    <Link
                        onClick={() => history.back()}
                        className="text-indigo-600 hover:text-indigo-700"
                    >
                        HR
                    </Link>
                    <span className="font-medium text-indigo-600"> /</span> Edit
                </h1>
            )}

            <DesignationTable users={hr.users} id={hr.id} canAdd={true} />
        </div>
    )
}

Edit.layout = page => <Layout title="Edit HR Record" children={page} />

export default Edit
